import { api, datesToISO, formatDate, saveAs } from "@";

export const exportNationalCenterReport = async ({ fromDate, toDate }) => {
  const fromIso = datesToISO(fromDate) || "";
  const toIso = datesToISO(toDate) || "";

  const response = await api.post(
    `/api/AdminOrder/export-orders-with-licence?fromDate=${fromIso}&toDate=${toIso}`,
    null,
    { responseType: "blob" },
  );

  const fileName = `تقارير الجمع للمركز الوطني( من-تاريخ-${formatDate(fromDate) || ""}-إلى-تاريخ-${formatDate(toDate) || ""})`;
  saveAs(new Blob([response.data]), `${fileName}.xlsx`);
};
